import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 md:mt-32 border-t border-ink/12">
      <div className="container-w py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-10 md:gap-x-8 items-start">
          {/* Wordmark — subtle, proportional */}
          <div className="md:col-span-3">
            <Link to="/" className="block">
              <img
                src="/brand/typography-greige.png"
                alt="TWP —"
                className="h-6 md:h-7 w-auto"
              />
            </Link>
            <p className="mono-label text-ash/70 mt-4 max-w-[26ch]">
              An architecture &amp; interior design practice, in Sydney.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="mono-label mb-2 text-ash">Contact</div>
            <a href="mailto:info@thewhiteprojectco.com" className="link-underline block" data-testid="footer-email">
              info@thewhiteprojectco.com
            </a>
            <div className="mt-4 text-ash text-sm">Sydney NSW, Australia</div>
            <div className="mt-1 text-ash text-sm">ABN 12 656 275 697</div>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-2 text-ash">Navigate</div>
            <ul className="space-y-1.5">
              <li><Link to="/work" className="link-underline">Work</Link></li>
              <li><Link to="/studio" className="link-underline">Studio</Link></li>
              <li><Link to="/studio#services-heading" className="link-underline">Services</Link></li>
              <li><Link to="/journal" className="link-underline">Journal</Link></li>
              <li><Link to="/contact" className="link-underline">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="mono-label mb-2 text-ash">Elsewhere</div>
            <ul className="space-y-1.5">
              <li><a href="https://instagram.com/thewhiteprojectco" target="_blank" rel="noreferrer" className="link-underline" data-testid="footer-instagram">Instagram</a></li>
              <li><Link to="/login" className="link-underline text-ash" data-testid="footer-admin">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2 md:justify-self-end">
            <div className="mono-label text-ash/70">© {new Date().getFullYear()}<br />The White Project Co.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
